import { useContext } from 'react'
import { defaultValue, SnackbarContext } from './SnackBarContext'

export function useSnackbarContext() {
  const context = useContext(SnackbarContext)

  if (context === defaultValue) {
    throw new Error('not used within a SnackbarProvider')
  }

  return context
}
